import { render, staticRenderFns } from "./FulfillmentError.vue?vue&type=template&id=670951fb"
import script from "./FulfillmentError.vue?vue&type=script&lang=ts"
export * from "./FulfillmentError.vue?vue&type=script&lang=ts"
import style0 from "./FulfillmentError.vue?vue&type=style&index=0&id=670951fb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports